/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from "../configuration";
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from "axios";
import globalAxios from "axios";
import { useAuthStore } from "@/stores/auth";
import { useClient } from "@/composables/useClient";
import { useNotificationStore } from "@/stores/notification";
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
  propertyMeta,
  MetaTypesBase,
} from "../common";
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  type RequestArgs,
  BaseAPI,
  RequiredError,
  operationServerMap,
} from "../base";
// @ts-ignore
import type { DonationDTO } from "../model";
import { DonationDTOTrackedI, DonationDTOMeta } from "../model";
// @ts-ignore
import type { DonationOptionsDTO } from "../model";
import { DonationOptionsDTOTrackedI, DonationOptionsDTOMeta } from "../model";
import { applyTransform } from "@/api/mappers/dtoDateMapper";
import { PaginatedResults } from "@/api/models/PaginatedResults";
/**
 * DonationApi - axios parameter creator
 * @export
 */
export const DonationApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * Returns donation funds and initiatives
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberDonationOptionsGet: (
      options: RawAxiosRequestConfig = {},
    ): RequestArgs => {
      const localVarPath = `/member/donation/options`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Returns a list of donations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberDonationsGet: (
      page?: number,
      pageSize?: number,
      options: RawAxiosRequestConfig = {},
    ): RequestArgs => {
      const localVarPath = `/member/donations`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      if (page !== undefined) {
        localVarQueryParameter["page"] = page;
      }
      if (pageSize !== undefined) {
        localVarQueryParameter["pageSize"] = pageSize;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

export type memberDonationOptionsGetParams = {};
export type memberDonationsGetParams = { page?: number; pageSize?: number };

export const memberDonationOptionsGetMeta = {};
export const memberDonationsGetMeta = {
  page: propertyMeta("page", false, true, false, MetaTypesBase.number),
  pageSize: propertyMeta("pageSize", false, true, false, MetaTypesBase.number),
};

/**
 * DonationApi - functional programming interface
 * @export
 */
export const useDonationApi = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = DonationApiAxiosParamCreator(configuration);
  const client = useClient();
  const authStore = useAuthStore();
  const notificationStore = useNotificationStore();
  return {
    /**
     * Returns donation funds and initiatives
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberDonationOptionsGetRaw(
      props: memberDonationOptionsGetParams,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<DonationOptionsDTO> {
      const localVarAxiosArgs =
        localVarAxiosParamCreator.memberDonationOptionsGet(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DonationApi.memberDonationOptionsGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<DonationOptionsDTO>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("DonationOptionsDTO", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Returns a list of donations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberDonationsGetRaw(
      props: memberDonationsGetParams,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<PaginatedResults<DonationDTO>> {
      authStore.requireAuth([
        // authentication member required
        "member",
      ]);
      const localVarAxiosArgs = localVarAxiosParamCreator.memberDonationsGet(
        props.page,
        props.pageSize,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DonationApi.memberDonationsGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<PaginatedResults<DonationDTO>>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("Array<DonationDTO>", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },

    /**
     * Returns donation funds and initiatives
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberDonationOptionsGet(
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<DonationOptionsDTO> {
      const localVarAxiosArgs =
        localVarAxiosParamCreator.memberDonationOptionsGet(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DonationApi.memberDonationOptionsGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<DonationOptionsDTO>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("DonationOptionsDTO", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Returns a list of donations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberDonationsGet(
      page?: number,
      pageSize?: number,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<PaginatedResults<DonationDTO>> {
      authStore.requireAuth([
        // authentication member required
        "member",
      ]);
      const localVarAxiosArgs = localVarAxiosParamCreator.memberDonationsGet(
        page,
        pageSize,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DonationApi.memberDonationsGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<PaginatedResults<DonationDTO>>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("Array<DonationDTO>", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
  };
};

/**
 * DonationApi - interface
 * @export
 * @interface DonationApi
 */
export interface DonationApiInterface {
  /**
   * Returns donation funds and initiatives
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DonationApiInterface
   */
  memberDonationOptionsGet(
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<DonationOptionsDTO>;

  /**
   * Returns a list of donations
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DonationApiInterface
   */
  memberDonationsGet(
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<Array<DonationDTO>>;
}
